export const SIZE = {
  SMALL: 'small',
  LARGE: 'large',
  MEDIUM: 'medium',
  NORMAL: 'normal'
};

export const VARIANT = {
  SOLID: 'solid',
  BORDERED: 'bordered',
  PLAIN: 'plain'
};

export const TYPE = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  DANGER: 'danger',
  TERTIARY: 'tertiary',
  LIGHT: 'light',
  DARK: 'dark',
  WARNING: 'warning',
  SUCCESS: 'success'
};
